const LOCAL_API_BASE = "http://localhost:5000/api/v1/company";
const PROD_API_BASE = "https://salesammo-api.girafdev.com/api/v1/company";

export const getApiBaseUrl = () => {
  const fromEnv = process.env.REACT_APP_API_BASE_URL?.trim();
  if (fromEnv) return fromEnv.replace(/\/+$/, "");

  return process.env.NODE_ENV === "development" ? LOCAL_API_BASE : PROD_API_BASE;
};

export const getApiOrigin = (apiBase = getApiBaseUrl()) => {
  const originMatch = String(apiBase).match(/^(https?:\/\/[^/]+)/i);
  return originMatch ? originMatch[1] : "";
};
